import { createReducer } from 'redux-act';
import actions from '../actions/ticketManagementActions';

const initialState = {
    createTicketPending: false,
    createTicketRes: null,
    createTicketError: null,

    getTicketPending: false,
    getTicketRes: null,
    getTicketError: null,


    getAllTicketPending: false,
    getAllTicketRes: null,
    getAllTicketError: null,

    updateTicketPending: false,
    updateTicketRes: null,
    updateTicketError: null,

    deleteTicketPending: false,
    deleteTicketRes: null,
    deleteTicketError: null,

    createTicketIssueTypePending: false,
    createTicketIssueTypeRes: null,
    createTicketIssueTypeError: null,

    getAllTicketTypePending: false,
    getAllTicketTypeRes: null,
    getAllTicketTypeError: null,

    getTicketIssueSubTypePending: false,
    getTicketIssueSubTypeRes: null,
    getTicketIssueSubTypeError: null,

    getAllTicketIssueTypePending: false,
    getAllTicketIssueTypeRes: null,
    getAllTicketIssueTypeError: null,

    updateTicketTypePending: false,
    updateTicketTypeRes: null,
    updateTicketTypeError: null,

    deleteTicketTypePending: false,
    deleteTicketTypeRes: null,
    deleteTicketTypeError: null,

    createTicketLogsPending: false,
    createTicketLogsRes: null,
    createTicketLogsError: null,

    getTicketLogsPending: false,
    getTicketLogsRes: null,
    getTicketLogsError: null,

    getAllTicketLogsPending: false,
    getAllTicketLogsRes: null,
    getAllTicketLogsError: null,

    updateTicketLogsPending: false,
    updateTicketLogsRes: null,
    updateTicketLogsError: null,

    deleteTicketLogsPending: false,
    deleteTicketLogsRes: null,
    deleteTicketLogsError: null,

    createTicketSettingPending: false,
    createTicketSettingRes: null,
    createTicketSettingError: null,

    getTicketSettingPending: false,
    getTicketSettingRes: null,
    getTicketSettingError: null,

    getAllTicketSettingPending: false,
    getAllTicketSettingRes: null,
    getAllTicketSettingError: null,

    updateTicketSettingPending: false,
    updateTicketSettingRes: null,
    updateTicketSettingError: null,

    deleteTicketSettingPending: false,
    deleteTicketSettingRes: null,
    deleteTicketSettingError: null,

    createTicketSettingPending: false,
    createTicketSettingRes: null,
    createTicketSettingError: null,

    getHelpDeskPending: false,
    getHelpDeskRes: null,
    getHelpDeskError: null,

    getAllHelpDeskPending: false,
    getAllHelpDeskRes: null,
    getAllHelpDeskError: null,

    updateHelpDeskPending: false,
    updateHelpDeskRes: null,
    updateHelpDeskError: null,

    deleteHelpDeskPending: false,
    deleteHelpDeskRes: null,
    deleteHelpDeskError: null,

    getTicketSummaryPending: false,
    getTicketSummaryRes: null,
    getTicketSummaryError: null,
};
/* Add Ticket Reducers */
const handleCreateTicketRequest = state => {
    return {
        ...state,
        ...{
            createTicketPending: true,
            createTicketRes: null,
            createTicketError: null,
        },
    };
};
const handleCreateTicketSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createTicketPending: false,
            createTicketRes: payload,
            createTicketError: null,
        },
    };
};
const handleCreateTicketError = (state, payload) => ({
    ...state,
    ...{
        createTicketPending: false,
        createTicketRes: null,
        createTicketError: payload,
    },
});


/* Get Ticket Reducers */
const handleGetTicketRequest = state1 => {
    return {
        ...state1,
        ...{
            getTicketPending: true,
            getTicketRes: null,
            getTicketError: null,
        },
    };
};
const handleGetTicketSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTicketPending: false,
            getTicketRes: payload,
            getTicketError: null,
        },
    };
};
const handleGetTicketError = (state1, payload) => ({
    ...state1,
    ...{
        getTicketPending: false,
        getTicketRes: null,
        getTicketError: payload,
    },
});


/* Get All Ticket Reducers */
const handleGetAllTicketRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTicketPending: true,
            getAllTicketRes: null,
            getAllTicketError: null,
        },
    };
};
const handleGetAllTicketSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketPending: false,
            getAllTicketRes: payload,
            getAllTicketError: null,
        },
    };
};
const handleGetAllTicketError = (state1, payload) => ({
    ...state1,
    ...{
        getAllTicketPending: false,
        getAllTicketRes: null,
        getAllTicketError: payload,
    },
});

/* Update Ticket Reducers*/
const handleUpdateTicketRequest = state1 => {
    return {
        ...state1,
        ...{
            updateTicketPending: true,
            updateTicketRes: null,
            updateTicketError: null,
        },
    };
};
const handleUpdateTicketSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTicketPending: false,
            updateTicketRes: payload,
            updateTicketError: null,
        },
    };
};
const handleUpdateTicketError = (state1, payload) => ({
    ...state1,
    ...{
        updateTicketPending: false,
        updateTicketRes: null,
        updateTicketError: payload,
    },
});

/* Delete Ticket Reducers*/
const handleDeleteTicketRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteTicketPending: true,
            deleteTicketRes: null,
            deleteTicketError: null,
        },
    };
};
const handleDeleteTicketSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTicketPending: false,
            deleteTicketRes: payload,
            deleteTicketError: null,
        },
    };
};
const handleDeleteTicketError = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTicketPending: false,
            deleteTicketRes: null,
            deleteTicketError: payload,
        },
    }
};

/* Create Ticket Issue Type Reducers*/
const handleCreateTicketIssueTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            createTicketIssueTypePending: true,
            createTicketIssueTypeRes: null,
            createTicketIssueTypeError: null,
        },
    };
};
const handleCreateTicketIssueTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createTicketIssueTypePending: false,
            createTicketIssueTypeRes: payload,
            createTicketIssueTypeError: null,
        },
    };
};
const handleCreateTicketIssueTypeError = (state1, payload) => {
    return {
        ...state1,
        ...{
            createTicketIssueTypePending: false,
            createTicketIssueTypeRes: null,
            createTicketIssueTypeError: payload,
        },
    }
};

/* Create Ticket Issue Type Reducers*/
const handleGetAllTicketTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTicketTypePending: true,
            getAllTicketTypeRes: null,
            getAllTicketTypeError: null,
        },
    };
};
const handleGetAllTicketTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketTypePending: false,
            getAllTicketTypeRes: payload,
            getAllTicketTypeError: null,
        },
    };
};
const handleGetAllTicketTypeError = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketTypePending: false,
            getAllTicketTypeRes: null,
            getAllTicketTypeError: payload,
        },
    }
};

/* Create Ticket Issue Type Reducers*/
const handleGetTicketIssueSubTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            getTicketIssueSubTypePending: true,
            getTicketIssueSubTypeRes: null,
            getTicketIssueSubTypeError: null,
        },
    };
};
const handleGetTicketIssueSubTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTicketIssueSubTypePending: false,
            getTicketIssueSubTypeRes: payload,
            getTicketIssueSubTypeError: null,
        },
    };
};
const handleGetTicketIssueSubTypeError = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTicketIssueSubTypePending: false,
            getTicketIssueSubTypeRes: null,
            getTicketIssueSubTypeError: payload,
        },
    }
};


/* Get All Ticket Issue Type Reducers*/
const handleGetAllTicketIssueTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTicketIssueTypePending: true,
            getAllTicketIssueTypeRes: null,
            getAllTicketIssueTypeError: null,
        },
    };
};
const handleGetAllTicketIssueTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketIssueTypePending: false,
            getAllTicketIssueTypeRes: payload,
            getAllTicketIssueTypeError: null,
        },
    };
};
const handleGetAllTicketIssueTypeError = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketIssueTypePending: false,
            getAllTicketIssueTypeRes: null,
            getAllTicketIssueTypeError: payload,
        },
    }
};

/* Get All Ticket Issue Type Reducers*/
const handleUpdateTicketTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            updateTicketTypePending: true,
            updateTicketTypeRes: null,
            updateTicketTypeError: null,
        },
    };
};
const handleUpdateTicketTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTicketTypePending: false,
            updateTicketTypeRes: payload,
            updateTicketTypeError: null,
        },
    };
};
const handleUpdateTicketTypeError = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTicketTypePending: false,
            updateTicketTypeRes: null,
            updateTicketTypeError: payload,
        },
    }
};


/* Delete Ticket Type Reducers*/
const handleDeleteTicketTypeRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteTicketTypePending: true,
            deleteTicketTypeRes: null,
            deleteTicketTypeError: null,
        },
    };
};
const handleDeleteTicketTypeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTicketTypePending: false,
            deleteTicketTypeRes: payload,
            deleteTicketTypeError: null,
        },
    };
};
const handleDeleteTicketTypeError = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTicketTypePending: false,
            deleteTicketTypeRes: null,
            deleteTicketTypeError: payload,
        },
    }
};

/* Add Ticket Logs Reducers */
const handleCreateTicketLogsRequest = state => {
    return {
        ...state,
        ...{
            createTicketLogsPending: true,
            createTicketLogsRes: null,
            createTicketLogsError: null,
        },
    };
};
const handleCreateTicketLogsSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createTicketLogsPending: false,
            createTicketLogsRes: payload,
            createTicketLogsError: null,
        },
    };
};
const handleCreateTicketLogsError = (state, payload) => ({
    ...state,
    ...{
        createTicketLogsPending: false,
        createTicketLogsRes: null,
        createTicketLogsError: payload,
    },
});


/* Get Ticket Logs Reducers */
const handleGetTicketLogsRequest = state1 => {
    return {
        ...state1,
        ...{
            getTicketLogsPending: true,
            getTicketLogsRes: null,
            getTicketLogsError: null,
        },
    };
};
const handleGetTicketLogsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTicketLogsPending: false,
            getTicketLogsRes: payload,
            getTicketLogsError: null,
        },
    };
};
const handleGetTicketLogsError = (state1, payload) => ({
    ...state1,
    ...{
        getTicketLogsPending: false,
        getTicketLogsRes: null,
        getTicketLogsError: payload,
    },
});


/* Get Ticket Logs by Department Reducers */
const handleGetAllTicketLogsRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTicketLogsPending: true,
            getAllTicketLogsRes: null,
            getAllTicketLogsError: null,
        },
    };
};
const handleGetAllTicketLogsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketLogsPending: false,
            getAllTicketLogsRes: payload,
            getAllTicketLogsError: null,
        },
    };
};
const handleGetAllTicketLogsError = (state1, payload) => ({
    ...state1,
    ...{
        getAllTicketLogsPending: false,
        getAllTicketLogsRes: null,
        getAllTicketLogsError: payload,
    },
});

/* Update Ticket Logs Reducers*/
const handleUpdateTicketLogsRequest = state1 => {
    return {
        ...state1,
        ...{
            updateTicketLogsPending: true,
            updateTicketLogsRes: null,
            updateTicketLogsError: null,
        },
    };
};
const handleUpdateTicketLogsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTicketLogsPending: false,
            updateTicketLogsRes: payload,
            updateTicketLogsError: null,
        },
    };
};
const handleUpdateTicketLogsError = (state1, payload) => ({
    ...state1,
    ...{
        updateTicketLogsPending: false,
        updateTicketLogsRes: null,
        updateTicketLogsError: payload,
    },
});

/* Delete Ticket Logs Reducers*/
const handleDeleteTicketLogsRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteTicketLogsPending: true,
            deleteTicketLogsRes: null,
            deleteTicketLogsError: null,
        },
    };
};
const handleDeleteTicketLogsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTicketLogsPending: false,
            deleteTicketLogsRes: payload,
            deleteTicketLogsError: null,
        },
    };
};
const handleDeleteTicketLogsError = (state1, payload) => ({
    ...state1,
    ...{
        deleteTicketLogsPending: false,
        deleteTicketLogsRes: null,
        deleteTicketLogsError: payload,
    },
});

/* Add Designation Reducers */
const handleCreateTicketSettingRequest = state => {
    return {
        ...state,
        ...{
            createTicketSettingPending: true,
            createTicketSettingRes: null,
            createTicketSettingError: null,
        },
    };
};
const handleCreateTicketSettingSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createTicketSettingPending: false,
            createTicketSettingRes: payload,
            createTicketSettingError: null,
        },
    };
};
const handleCreateTicketSettingError = (state, payload) => ({
    ...state,
    ...{
        createTicketSettingPending: false,
        createTicketSettingRes: null,
        createTicketSettingError: payload,
    },
});


/* Get Designation Reducers */
const handleGetTicketSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            getTicketSettingPending: true,
            getTicketSettingRes: null,
            getTicketSettingError: null,
        },
    };
};
const handleGetTicketSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTicketSettingPending: false,
            getTicketSettingRes: payload,
            getTicketSettingError: null,
        },
    };
};
const handleGetTicketSettingError = (state1, payload) => ({
    ...state1,
    ...{
        getTicketSettingPending: false,
        getTicketSettingRes: null,
        getTicketSettingError: payload,
    },
});


/* Get Designation by Department Reducers */
const handleGetAllTicketSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTicketSettingPending: true,
            getAllTicketSettingRes: null,
            getAllTicketSettingError: null,
        },
    };
};
const handleGetAllTicketSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTicketSettingPending: false,
            getAllTicketSettingRes: payload,
            getAllTicketSettingError: null,
        },
    };
};
const handleGetAllTicketSettingError = (state1, payload) => ({
    ...state1,
    ...{
        getAllTicketSettingPending: false,
        getAllTicketSettingRes: null,
        getAllTicketSettingError: payload,
    },
});

/* Update Designation Reducers*/
const handleUpdateTicketSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            updateTicketSettingPending: true,
            updateTicketSettingRes: null,
            updateTicketSettingError: null,
        },
    };
};
const handleUpdateTicketSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTicketSettingPending: false,
            updateTicketSettingRes: payload,
            updateTicketSettingError: null,
        },
    };
};
const handleUpdateTicketSettingError = (state1, payload) => ({
    ...state1,
    ...{
        updateTicketSettingPending: false,
        updateTicketSettingRes: null,
        updateTicketSettingError: payload,
    },
});

/* Delete Designation Reducers*/
const handleDeleteTicketSettingRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteTicketSettingPending: true,
            deleteTicketSettingRes: null,
            deleteTicketSettingError: null,
        },
    };
};
const handleDeleteTicketSettingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTicketSettingPending: false,
            deleteTicketSettingRes: payload,
            deleteTicketSettingError: null,
        },
    };
};
const handleDeleteTicketSettingError = (state1, payload) => ({
    ...state1,
    ...{
        deleteTicketSettingPending: false,
        deleteTicketSettingRes: null,
        deleteTicketSettingError: payload,
    },
});



/* Add Help Desk Reducers */
const handleCreateHelpDeskRequest = state => {
    return {
        ...state,
        ...{
            createHelpDeskPending: true,
            createHelpDeskRes: null,
            createHelpDeskError: null,
        },
    };
};
const handleCreateHelpDeskSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createHelpDeskPending: false,
            createHelpDeskRes: payload,
            createHelpDeskError: null,
        },
    };
};
const handleCreateHelpDeskError = (state, payload) => ({
    ...state,
    ...{
        createHelpDeskPending: false,
        createHelpDeskRes: null,
        createHelpDeskError: payload,
    },
});


/* Get Help Desk Reducers */
const handleGetHelpDeskRequest = state1 => {
    return {
        ...state1,
        ...{
            getHelpDeskPending: true,
            getHelpDeskRes: null,
            getHelpDeskError: null,
        },
    };
};
const handleGetHelpDeskSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getHelpDeskPending: false,
            getHelpDeskRes: payload,
            getHelpDeskError: null,
        },
    };
};
const handleGetHelpDeskError = (state1, payload) => ({
    ...state1,
    ...{
        getHelpDeskPending: false,
        getHelpDeskRes: null,
        getHelpDeskError: payload,
    },
});


/* Get all Help Desk Reducers */
const handleGetAllHelpDeskRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllHelpDeskPending: true,
            getAllHelpDeskRes: null,
            getAllHelpDeskError: null,
        },
    };
};
const handleGetAllHelpDeskSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllHelpDeskPending: false,
            getAllHelpDeskRes: payload,
            getAllHelpDeskError: null,
        },
    };
};
const handleGetAllHelpDeskError = (state1, payload) => ({
    ...state1,
    ...{
        getAllHelpDeskPending: false,
        getAllHelpDeskRes: null,
        getAllHelpDeskError: payload,
    },
});

/* Update Help Desk Reducers*/
const handleUpdateHelpDeskRequest = state1 => {
    return {
        ...state1,
        ...{
            updateHelpDeskPending: true,
            updateHelpDeskRes: null,
            updateHelpDeskError: null,
        },
    };
};
const handleUpdateHelpDeskSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateHelpDeskPending: false,
            updateHelpDeskRes: payload,
            updateHelpDeskError: null,
        },
    };
};
const handleUpdateHelpDeskError = (state1, payload) => ({
    ...state1,
    ...{
        updateHelpDeskPending: false,
        updateHelpDeskRes: null,
        updateHelpDeskError: payload,
    },
});

/* Delete Help Desk Reducers*/
const handleDeleteHelpDeskRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteHelpDeskPending: true,
            deleteHelpDeskRes: null,
            deleteHelpDeskError: null,
        },
    };
};
const handleDeleteHelpDeskSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteHelpDeskPending: false,
            deleteHelpDeskRes: payload,
            deleteHelpDeskError: null,
        },
    };
};
const handleDeleteHelpDeskError = (state1, payload) => ({
    ...state1,
    ...{
        deleteHelpDeskPending: false,
        deleteHelpDeskRes: null,
        deleteHelpDeskError: payload,
    },
});


/* Delete Help Desk Reducers*/
const handleGetTicketSummaryRequest = state1 => {
    return {
        ...state1,
        ...{
            getTicketSummaryPending: true,
            getTicketSummaryRes: null,
            getTicketSummaryError: null,
        },
    };
};
const handleGetTicketSummarySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTicketSummaryPending: false,
            getTicketSummaryRes: payload,
            getTicketSummaryError: null,
        },
    };
};
const handleGetTicketSummaryError = (state1, payload) => ({
    ...state1,
    ...{
        getTicketSummaryPending: false,
        getTicketSummaryRes: null,
        getTicketSummaryError: payload,
    },
});



/* Clear Ticket Logs Store */
const clearTicketStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_CREATE_TICKET_STORE':
            return {
                ...state,
                ...{
                    createTicketPending: false,
                    createTicketRes: null,
                    createTicketError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TICKET_STORE':
            return {
                ...state,
                ...{
                    updateTicketPending: false,
                    updateTicketRes: null,
                    updateTicketError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TICKET_STORE':
            return {
                ...state,
                ...{
                    deleteTicketPending: false,
                    deleteTicketRes: null,
                    deleteTicketError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_TICKET_STORE':
            return {
                ...state,
                ...{
                    getTicketPending: false,
                    getTicketRes: null,
                    getTicketError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_TICKET_STORE':
            return {
                ...state,
                ...{
                    getAllTicketPending: false,
                    getAllTicketRes: null,
                    getAllTicketError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TICKET_ISSUE_STORE':
            return {
                ...state,
                ...{
                    deleteTicketIssuePending: false,
                    deleteTicketIssueRes: null,
                    deleteTicketIssueError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_TICKET_ISSUE_TYPE_STORE':
            return {
                ...state,
                ...{
                    createTicketIssueTypePending: false,
                    createTicketIssueTypeRes: null,
                    createTicketIssueTypeError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TICKET_ISSUE_TYPE_STORE':
            return {
                ...state,
                ...{
                    updateTicketTypePending: false,
                    updateTicketTypeRes: null,
                    updateTicketTypeError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TICKET_ISSUE_TYPE_STORE':
            return {
                ...state,
                ...{
                    deleteTicketTypePending: false,
                    deleteTicketTypeRes: null,
                    deleteTicketTypeError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_TICKET_ISSUE_TYPE_STORE':
            return {
                ...state,
                ...{
                    getAllTicketTypePending: false,
                    getAllTicketTypeRes: null,
                    getAllTicketTypeError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_TICKET_ISSUE_TYPE_STORE':
            return {
                ...state,
                ...{
                    getAllTicketIssueTypePending: false,
                    getAllTicketIssueTypeRes: null,
                    getAllTicketIssueTypeError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_TICKET_LOGS_STORE':
            return {
                ...state,
                ...{
                    createTicketLogsPending: false,
                    createTicketLogsRes: null,
                    createTicketLogsError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TICKET_LOGS_STORE':
            return {
                ...state,
                ...{
                    updateTicketLogsPending: false,
                    updateTicketLogsRes: null,
                    updateTicketLogsError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TICKET_LOGS_STORE':
            return {
                ...state,
                ...{
                    deleteTicketLogsPending: false,
                    deleteTicketLogsRes: null,
                    deleteTicketLogsError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_TICKET_SETTING_STORE':
            return {
                ...state,
                ...{
                    createTicketSettingPending: false,
                    createTicketSettingRes: null,
                    createTicketSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_TICKET_SETTING_STORE':
            return {
                ...state,
                ...{
                    getTicketSettingPending: false,
                    getTicketSettingRes: null,
                    getTicketSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_TICKET_SETTING_STORE':
            return {
                ...state,
                ...{
                    getAllTicketSettingPending: false,
                    getAllTicketSettingRes: null,
                    getAllTicketSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TICKET_SETTING_STORE':
            return {
                ...state,
                ...{
                    updateTicketSettingPending: false,
                    updateTicketSettingRes: null,
                    updateTicketSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TICKET_SETTING_STORE':
            return {
                ...state,
                ...{
                    deleteTicketSettingPending: false,
                    deleteTicketSettingRes: null,
                    deleteTicketSettingError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_HELP_DESK_STORE':
            return {
                ...state,
                ...{
                    createHelpDeskPending: false,
                    createHelpDeskRes: null,
                    createHelpDeskError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_HELP_DESK_STORE':
            return {
                ...state,
                ...{
                    getHelpDeskPending: false,
                    getHelpDeskRes: null,
                    getHelpDeskError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_HELP_DESK_STORE':
            return {
                ...state,
                ...{
                    getAllHelpDeskPending: false,
                    getAllHelpDeskRes: null,
                    getAllHelpDeskError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_HELP_DESK_STORE':
            return {
                ...state,
                ...{
                    updateHelpDeskPending: false,
                    updateHelpDeskRes: null,
                    updateHelpDeskError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_HELP_DESK_STORE':
            return {
                ...state,
                ...{
                    deleteHelpDeskPending: false,
                    deleteHelpDeskRes: null,
                    deleteHelpDeskError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.createTicketRequest]: handleCreateTicketRequest,
        [actions.createTicketSuccess]: handleCreateTicketSuccess,
        [actions.createTicketError]: handleCreateTicketError,

        [actions.getTicketRequest]: handleGetTicketRequest,
        [actions.getTicketSuccess]: handleGetTicketSuccess,
        [actions.getTicketError]: handleGetTicketError,

        [actions.getAllTicketRequest]: handleGetAllTicketRequest,
        [actions.getAllTicketSuccess]: handleGetAllTicketSuccess,
        [actions.getAllTicketError]: handleGetAllTicketError,

        [actions.updateTicketRequest]: handleUpdateTicketRequest,
        [actions.updateTicketSuccess]: handleUpdateTicketSuccess,
        [actions.updateTicketError]: handleUpdateTicketError,

        [actions.deleteTicketRequest]: handleDeleteTicketRequest,
        [actions.deleteTicketSuccess]: handleDeleteTicketSuccess,
        [actions.deleteTicketError]: handleDeleteTicketError,

        [actions.createTicketIssueTypeRequest]: handleCreateTicketIssueTypeRequest,
        [actions.createTicketIssueTypeSuccess]: handleCreateTicketIssueTypeSuccess,
        [actions.createTicketIssueTypeError]: handleCreateTicketIssueTypeError,

        [actions.getAllTicketTypeRequest]: handleGetAllTicketTypeRequest,
        [actions.getAllTicketTypeSuccess]: handleGetAllTicketTypeSuccess,
        [actions.getAllTicketTypeError]: handleGetAllTicketTypeError,

        [actions.getTicketIssueSubTypeRequest]: handleGetTicketIssueSubTypeRequest,
        [actions.getTicketIssueSubTypeSuccess]: handleGetTicketIssueSubTypeSuccess,
        [actions.getTicketIssueSubTypeError]: handleGetTicketIssueSubTypeError,

        [actions.getAllTicketIssueTypeRequest]: handleGetAllTicketIssueTypeRequest,
        [actions.getAllTicketIssueTypeSuccess]: handleGetAllTicketIssueTypeSuccess,
        [actions.getAllTicketIssueTypeError]: handleGetAllTicketIssueTypeError,

        [actions.updateTicketTypeRequest]: handleUpdateTicketTypeRequest,
        [actions.updateTicketTypeSuccess]: handleUpdateTicketTypeSuccess,
        [actions.updateTicketTypeError]: handleUpdateTicketTypeError,

        [actions.deleteTicketTypeRequest]: handleDeleteTicketTypeRequest,
        [actions.deleteTicketTypeSuccess]: handleDeleteTicketTypeSuccess,
        [actions.deleteTicketTypeError]: handleDeleteTicketTypeError,

        [actions.createTicketLogsRequest]: handleCreateTicketLogsRequest,
        [actions.createTicketLogsSuccess]: handleCreateTicketLogsSuccess,
        [actions.createTicketLogsError]: handleCreateTicketLogsError,

        [actions.getTicketLogsRequest]: handleGetTicketLogsRequest,
        [actions.getTicketLogsSuccess]: handleGetTicketLogsSuccess,
        [actions.getTicketLogsError]: handleGetTicketLogsError,

        [actions.getAllTicketLogsRequest]: handleGetAllTicketLogsRequest,
        [actions.getAllTicketLogsSuccess]: handleGetAllTicketLogsSuccess,
        [actions.getAllTicketLogsError]: handleGetAllTicketLogsError,

        [actions.updateTicketLogsRequest]: handleUpdateTicketLogsRequest,
        [actions.updateTicketLogsSuccess]: handleUpdateTicketLogsSuccess,
        [actions.updateTicketLogsError]: handleUpdateTicketLogsError,

        [actions.deleteTicketLogsRequest]: handleDeleteTicketLogsRequest,
        [actions.deleteTicketLogsSuccess]: handleDeleteTicketLogsSuccess,
        [actions.deleteTicketLogsError]: handleDeleteTicketLogsError,

        [actions.createTicketSettingRequest]: handleCreateTicketSettingRequest,
        [actions.createTicketSettingSuccess]: handleCreateTicketSettingSuccess,
        [actions.createTicketSettingError]: handleCreateTicketSettingError,

        [actions.getTicketSettingRequest]: handleGetTicketSettingRequest,
        [actions.getTicketSettingSuccess]: handleGetTicketSettingSuccess,
        [actions.getTicketSettingError]: handleGetTicketSettingError,

        [actions.getAllTicketSettingRequest]: handleGetAllTicketSettingRequest,
        [actions.getAllTicketSettingSuccess]: handleGetAllTicketSettingSuccess,
        [actions.getAllTicketSettingError]: handleGetAllTicketSettingError,

        [actions.updateTicketSettingRequest]: handleUpdateTicketSettingRequest,
        [actions.updateTicketSettingSuccess]: handleUpdateTicketSettingSuccess,
        [actions.updateTicketSettingError]: handleUpdateTicketSettingError,

        [actions.deleteTicketSettingRequest]: handleDeleteTicketSettingRequest,
        [actions.deleteTicketSettingSuccess]: handleDeleteTicketSettingSuccess,
        [actions.deleteTicketSettingError]: handleDeleteTicketSettingError,

        [actions.createHelpDeskRequest]: handleCreateHelpDeskRequest,
        [actions.createHelpDeskSuccess]: handleCreateHelpDeskSuccess,
        [actions.createHelpDeskError]: handleCreateHelpDeskError,

        [actions.getHelpDeskRequest]: handleGetHelpDeskRequest,
        [actions.getHelpDeskSuccess]: handleGetHelpDeskSuccess,
        [actions.getHelpDeskError]: handleGetHelpDeskError,

        [actions.getAllHelpDeskRequest]: handleGetAllHelpDeskRequest,
        [actions.getAllHelpDeskSuccess]: handleGetAllHelpDeskSuccess,
        [actions.getAllHelpDeskError]: handleGetAllHelpDeskError,

        [actions.updateHelpDeskRequest]: handleUpdateHelpDeskRequest,
        [actions.updateHelpDeskSuccess]: handleUpdateHelpDeskSuccess,
        [actions.updateHelpDeskError]: handleUpdateHelpDeskError,

        [actions.deleteHelpDeskRequest]: handleDeleteHelpDeskRequest,
        [actions.deleteHelpDeskSuccess]: handleDeleteHelpDeskSuccess,
        [actions.deleteHelpDeskError]: handleDeleteHelpDeskError,

        [actions.getTicketSummaryRequest]: handleGetTicketSummaryRequest,
        [actions.getTicketSummarySuccess]: handleGetTicketSummarySuccess,
        [actions.getTicketSummaryError]: handleGetTicketSummaryError,

        [actions.handleClearTicketStore]: clearTicketStore,
    },
    initialState,
);